<!-- Modal: Ajuste Manual CLP -->
<div style="max-width: 500px; width: 100%;">
  <!-- Header -->
  <div [style.background]="tipo === 'Agregar' ? 'linear-gradient(135deg, #f0fdf4, #ecfdf5)' : (tipo === 'Debitar' ? 'linear-gradient(135deg, #fff7ed, #ffedd5)' : 'linear-gradient(135deg, #fef2f2, #fee2e2)')"
    [style.border-bottom]="tipo === 'Agregar' ? '2px solid #bbf7d0' : (tipo === 'Debitar' ? '2px solid #fed7aa' : '2px solid #fecaca')"
    style="padding: 20px 24px;">
    <h3 style="margin: 0; font-size: 1.1rem; font-weight: 800; display: flex; align-items: center; gap: 10px;"
      [style.color]="tipo === 'Agregar' ? '#1e5a3f' : (tipo === 'Debitar' ? '#9a3412' : '#991b1b')">
      <mat-icon style="font-size: 24px; width: 24px; height: 24px;"
        [style.color]="tipo === 'Agregar' ? '#16a34a' : (tipo === 'Debitar' ? '#ea580c' : '#dc2626')">
        {{ tipo === 'Agregar' ? 'add_circle' : (tipo === 'Debitar' ? 'arrow_downward' : 'remove_circle') }}
      </mat-icon>
      {{ tipo }} Saldo CLP
    </h3>
  </div>

  <!-- Content -->
  <div style="padding: 20px 24px;">
    <!-- User Info Card -->
    <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px; padding: 16px; margin-bottom: 20px;">
      <h4 style="font-size: 0.8rem; font-weight: 700; color: #6b7280; text-transform: uppercase; letter-spacing: 0.5px; margin: 0 0 12px 0; display: flex; align-items: center; gap: 6px;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">person</mat-icon>
        Informacion del Usuario
      </h4>
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
        <div>
          <span style="font-size: 0.7rem; color: #9ca3af; font-weight: 600; text-transform: uppercase;">Nombre</span>
          <p style="margin: 2px 0 0; font-size: 0.85rem; font-weight: 600; color: #374151;">{{ data.userInfo?.nombre }} {{ data.userInfo?.apellidos }}</p>
        </div>
        <div>
          <span style="font-size: 0.7rem; color: #9ca3af; font-weight: 600; text-transform: uppercase;">ID</span>
          <p style="margin: 2px 0 0; font-size: 0.85rem; font-weight: 600; color: #374151; font-family: monospace;">{{ data.userInfo?.usuarioId }}</p>
        </div>
        <div>
          <span style="font-size: 0.7rem; color: #9ca3af; font-weight: 600; text-transform: uppercase;">Documento</span>
          <p style="margin: 2px 0 0; font-size: 0.85rem; font-weight: 600; color: #374151;">{{ data.userInfo?.tipoId }} - {{ formatDocument() }}</p>
        </div>
        <div>
          <span style="font-size: 0.7rem; color: #9ca3af; font-weight: 600; text-transform: uppercase;">Email</span>
          <p style="margin: 2px 0 0; font-size: 0.85rem; font-weight: 600; color: #374151; word-break: break-all;">{{ data.userInfo?.email }}</p>
        </div>
      </div>
      <!-- Saldo actual -->
      <div style="margin-top: 12px; padding-top: 12px; border-top: 1px solid #e5e7eb; display: flex; justify-content: space-between; align-items: center;">
        <span style="font-size: 0.85rem; font-weight: 600; color: #6b7280;">Saldo Actual:</span>
        <span style="font-size: 1.1rem; font-weight: 800; color: #1e5a3f;">{{ data.saldo | currency:'$':'symbol':'1.0-0' }} CLP</span>
      </div>
    </div>

    <!-- Warning para Quitar -->
    <div *ngIf="tipo === 'Quitar'" style="display: flex; align-items: flex-start; gap: 8px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 10px; padding: 12px 16px; margin-bottom: 20px;">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #dc2626; flex-shrink: 0; margin-top: 1px;">warning</mat-icon>
      <div>
        <p style="margin: 0; font-size: 0.85rem; font-weight: 700; color: #991b1b;">Esta accion dejara el saldo en $0</p>
        <p style="margin: 4px 0 0; font-size: 0.78rem; color: #991b1b;">Se eliminara todo el saldo disponible del usuario.</p>
      </div>
    </div>

    <!-- Form -->
    <form [formGroup]="form">
      <mat-form-field *ngIf="!tipo.includes('Quitar')" appearance="outline" class="w-full modern-field" style="margin-bottom: 8px;">
        <mat-label>Monto</mat-label>
        <mat-icon matPrefix style="color: #6b7280;">attach_money</mat-icon>
        <input matInput matInputCommified placeholder="Ingresa el monto" formControlName="value" appOnlynumber required>
        <span matTextPrefix>$&nbsp;</span>
        <mat-error *ngIf="form.controls['value'].hasError('required')">El monto es requerido</mat-error>
        <mat-error *ngIf="form.controls['value'].hasError('pattern')">El monto debe ser un numero</mat-error>
        <mat-error *ngIf="form.controls['value'].hasError('min')">El monto debe ser mayor a 0</mat-error>
        <mat-error *ngIf="form.controls['value'].hasError('max')">El monto debe ser menor o igual a {{ data.saldo | currency:'' }}</mat-error>
      </mat-form-field>
    </form>
  </div>

  <!-- Footer -->
  <div style="padding: 16px 24px; border-top: 1px solid #e5e7eb; display: flex; flex-direction: column; gap: 10px;">
    <div style="display: flex; flex-direction: row; gap: 10px; justify-content: flex-end;" class="flex-col sm:flex-row">
      <button type="button" (click)="onNoClick()"
        style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 10px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease; flex: 1;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">close</mat-icon>
        Cancelar
      </button>
      <button type="button" #submitBtn (click)="adjustmentExecution()"
        [disabled]="form.invalid && !tipo.includes('Quitar')"
        [style.opacity]="(form.invalid && !tipo.includes('Quitar')) ? '0.5' : '1'"
        [style.cursor]="(form.invalid && !tipo.includes('Quitar')) ? 'not-allowed' : 'pointer'"
        [style.background]="tipo === 'Agregar' ? '#1C593D' : (tipo === 'Debitar' ? '#ea580c' : '#dc2626')"
        style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 10px 24px; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease; flex: 1;"
        (mouseover)="submitBtn.style.background = tipo === 'Agregar' ? '#059669' : (tipo === 'Debitar' ? '#c2410c' : '#b91c1c')"
        (mouseout)="submitBtn.style.background = tipo === 'Agregar' ? '#1C593D' : (tipo === 'Debitar' ? '#ea580c' : '#dc2626')">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">
          {{ tipo === 'Agregar' ? 'add_circle' : (tipo === 'Debitar' ? 'arrow_downward' : 'delete_forever') }}
        </mat-icon>
        {{ tipo === 'Quitar' ? 'Confirmar Quitar Todo' : 'Guardar' }}
      </button>
    </div>
  </div>
</div>
